import axios from 'axios'
import { CALCULAR_ACRESCIMO_PASSAGEM_USUARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function calcularAcrescimoPassagem (valorTotal, percentualAcrescimo) {
  const url = `${URL}/passagem/valor/${valorTotal}/acrescimo/${percentualAcrescimo}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CALCULAR_ACRESCIMO_PASSAGEM_USUARIO,
        payload: response

      })
  );
}
